export default __webpack_public_path__ + "static/media/logo.d6766f15.png";